import {Component, input} from '@angular/core';

/**
 * The scrolling body of a `layout-page-container` page — and the page's **only** scroll container.
 *
 * It is a flex slot (`flex-1 min-h-0`) that claims whatever column height the page header and toolbars leave
 * over. The scroll box inside it spans the page **edge to edge** (the host cancels the container's gutter) and
 * the breathing room is applied to the content within, so the scrollbar sits on the page's real edge with no
 * dead strip beside it and the top gutter scrolls away with the list.
 *
 * See `docs/articles/frontend/page-layout-contract.md` for the contract this participates in (#235).
 */
@Component({
  selector: 'layout-page-scrollable',
  imports: [],
  templateUrl: './page-scrollable.component.html',
  styleUrl: './page-scrollable.component.scss'
})
export class PageScrollableComponent {
  /**
   * Whether a page header (`layout-header-container`) sits above this scroll area — true for every page but one.
   *
   * It drives the two things that depend on having a header: the hairline rule that separates the frozen header
   * area from the scrolling body, and where the page's top gutter comes from. Set it to `false` when this
   * component is the page container's first child (`event-details`), so the rule does not underline nothing and
   * the top gutter is applied to the scrolling content instead of the header.
   */
  readonly hasPageHeader = input(true);
}
